export const screenName = 'management-analysis-details';
